import { render, staticRenderFns } from "./EditCustomerDetails.vue?vue&type=template&id=9709dab6&"
import script from "./EditCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./EditCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1751410358/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9709dab6')) {
      api.createRecord('9709dab6', component.options)
    } else {
      api.reload('9709dab6', component.options)
    }
    module.hot.accept("./EditCustomerDetails.vue?vue&type=template&id=9709dab6&", function () {
      api.rerender('9709dab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/EditCustomerDetails.vue"
export default component.exports